import requests from "@/request/index";

// 列出学校
export const getschool = (data: any) => requests({ url: "api/cloud/device/school", method: "GET", params: data })